import PropTypes from 'prop-types';
import React from 'react';
import Dropzone from 'react-dropzone';
import { Icon } from 'signoxe/components/widgets';
import './styles.scss';


const AssetDropzone = ({ onDrop, MAX_Size, file_size_message, accept, instruction,handleDropRejected }) => {

  console.log("Asset dropzone params");
  console.log("MAX_SIZE", MAX_Size);

  console.log("Accept params", accept);
  
  return (
  <Dropzone onDrop={onDrop}
    accept={accept}
    onDropRejected={handleDropRejected}
    className="asset-upload"
    activeClassName="asset-upload active"
    maxSize={MAX_Size}
  >
    <div className="show-for-large">
      {instruction}
    </div>
    <div className="small show-for-large">
      Supported image types are <em>PNG</em> and <em>JPEG</em>,&nbsp;
      and supported video formats are <em>MP4</em> and <em>WEBM</em>.
      {file_size_message}
    </div>
    <div className="hide-for-large button large">
      <Icon name="upload" color="white"/>
      Upload videos or images
    </div>
  </Dropzone>
);
}

AssetDropzone.propTypes = {
  onDrop: PropTypes.func.isRequired,
};

export default AssetDropzone;


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/AssetDropzone/index.js